if (!customElements.get('kofler-cold-shipping')) {
  customElements.define('kofler-cold-shipping', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('button');
      this.tooltip = this.querySelector('[role="tooltip"]');
      if (!this.trigger || !this.tooltip) return;
      this.show = () => this.setOpen(true);
      this.onLeave = () => {
        if (!this.contains(document.activeElement)) this.setOpen(false);
      };
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.setOpen(false);
      };
      this.onOutside = (event) => {
        if (!this.contains(event.target)) this.setOpen(false);
      };
      this.onKey = (event) => {
        if (event.key === 'Escape') this.setOpen(false);
      };
      this.trigger.addEventListener('click', this.show);
      this.addEventListener('mouseenter', this.show);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.show);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('pointerdown', this.onOutside);
      document.addEventListener('keydown', this.onKey);
    }

    setOpen(open) {
      if (this.tooltip.hidden === open) this.tooltip.hidden = !open;
      const expanded = String(open);
      if (this.trigger.getAttribute('aria-expanded') !== expanded) this.trigger.setAttribute('aria-expanded', expanded);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.show);
      this.removeEventListener('mouseenter', this.show);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeEventListener('focusin', this.show);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('pointerdown', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }
  });
}
